<template>
    <div>
        <button
            ref="buttonRef"
            type="button"
            class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-gray-300 text-gray-600 transition hover:bg-gray-50"
            :aria-label="t('vue.ai_chat_capabilities_help')"
            :title="t('vue.ai_chat_capabilities_help')"
            @click="toggle"
        >
            <QuestionMarkCircleIcon class="h-5 w-5" />
        </button>

        <!-- Teleported so the chat panel's overflow never clips the popover. -->
        <Teleport to="body">
            <template v-if="open">
                <div class="fixed inset-0 z-[590]" @click="open = false" />
                <div
                    class="fixed z-[600] w-72 rounded-xl border border-gray-200 bg-white p-4 shadow-lg"
                    :style="menuStyle"
                >
                    <p
                        class="mb-2 text-[11px] font-medium uppercase tracking-wide text-gray-400"
                    >
                        {{ t("vue.ai_chat_capabilities_title") }}
                    </p>
                    <ul class="grid gap-1.5">
                        <li
                            v-for="capability in capabilities"
                            :key="capability"
                            class="flex items-start gap-2 text-sm text-gray-700"
                        >
                            <CheckIcon
                                class="mt-0.5 h-4 w-4 shrink-0 text-green-500"
                            />
                            <span>{{ capability }}</span>
                        </li>
                    </ul>
                </div>
            </template>
        </Teleport>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { QuestionMarkCircleIcon, CheckIcon } from "@heroicons/vue/24/outline";
import { useTranslations } from "@/composables/useTranslations";

const { t } = useTranslations();

const open = ref(false);
const buttonRef = ref<HTMLElement | null>(null);
const menuStyle = ref<Record<string, string>>({});

const toggle = (): void => {
    if (open.value) {
        open.value = false;
        return;
    }
    const rect = buttonRef.value?.getBoundingClientRect();
    if (rect) {
        menuStyle.value = {
            top: `${rect.bottom + 4}px`,
            right: `${window.innerWidth - rect.right}px`,
        };
    }
    open.value = true;
};

const capabilities = computed(() => [
    t("vue.ai_chat_cap_dashboard"),
    t("vue.ai_chat_cap_domains"),
    t("vue.ai_chat_cap_reports"),
    t("vue.ai_chat_cap_blacklists"),
    t("vue.ai_chat_cap_alerts"),
    t("vue.ai_chat_cap_team"),
    t("vue.ai_chat_cap_billing"),
]);
</script>
